import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AnswerModel } from '../models/answer.model';
import { ObjectModel } from '../models/object.model';
import { ExecuteLogicRequestModel } from '../models/execute-logic-request.model';
import { ApiService } from './api.service';
import { LogicResponseModel } from '../models/logic.model';

@Injectable()
export class LogicService {
  constructor(private apiService: ApiService) {}

  executeLogic(
    qToken: string,
    answer: string,
    iObjects: Array<ObjectModel>,
    answers: Array<AnswerModel>,
    praSysId?: number,
    templateId?: number,
    tokens?: Array<string>,
    documentTitle?: string
  ): Observable<any> {
    const model: ExecuteLogicRequestModel = {
      qToken: qToken,
      iObjects: iObjects,
      answer: answer,
      answers: answers,
      praSysId: praSysId,
      templateId: templateId,
      tokens: tokens,
    };

    model.answers?.push({ token: "X00003X", answer: documentTitle ?? '', praSysId: 1, dimIndex: '', answerChoice: '' });

    const headers = new HttpHeaders();

    return this.apiService.post<LogicResponseModel>(`logic/executelogic`, model, { showToast: true });
  }
}
